import Cookies from 'js-cookie';

const USER_INFO_KEY = "userDetails";

// Save user info in cookies
export const setUserInfo = (userInfo, expiresInDays = 7) => {
    Cookies.set(USER_INFO_KEY, JSON.stringify(userInfo), { expires: expiresInDays, secure: true, sameSite: 'Strict' });
};

// Get user info from cookies
export const getUserInfo = () => {
    const userInfo = Cookies.get(USER_INFO_KEY);
    return userInfo ? JSON.parse(userInfo) : null;
};

// Remove user info (logout)
export const removeUserInfo = () => {
    Cookies.remove(USER_INFO_KEY);
};

// Check if user is authenticated
export const isAuthenticated = () => {
    const user = getUserInfo();
    return user && user.token ? true : false;
};
